export const emptyUserData = {
  access_token: "",
  expires_in: 0,
  token_type: "",
  scope: "",
  refresh_token: "",
};
